import React, { useContext, useState, useMemo } from 'react';
import './CSS/ShopCategory.css';
import { ShopContext } from '../Context/ShopContext';
import Item from '../Components/Item/Item';

const ShopCategory = (props) => {
    const { all_Product } = useContext(ShopContext);

    // State for user selections
    const [visibleItems, setVisibleItems] = useState(12);
    const [sortOrder, setSortOrder] = useState('default');
    const [selectedBrand, setSelectedBrand] = useState('All');

    // UseMemo to efficiently calculate the list of brands for the current category
    const categoryBrands = useMemo(() => {
        const brands = new Set(
            all_Product
                .filter(item => item.category === props.category)
                .map(item => item.brand)
                .filter(Boolean) // Remove any undefined/null brands
        );
        return ['All', ...brands];
    }, [all_Product, props.category]);

    // useMemo to efficiently filter and sort products whenever a dependency changes
    const displayedProducts = useMemo(() => {
        let products = all_Product.filter(item => item.category === props.category);

        if (selectedBrand !== 'All') {
            products = products.filter(item => item.brand === selectedBrand);
        }

        return products.sort((a, b) => {
            switch (sortOrder) {
                case 'price-asc': return a.new_price - b.new_price;
                case 'price-desc': return b.new_price - a.new_price;
                default: return 0;
            }
        });
    }, [all_Product, props.category, selectedBrand, sortOrder]);

    const handleLoadMore = () => {
        setVisibleItems(prev => prev + 12);
    };

    const categoryTitles = {
        sketch: "Sketch.",
        gulueffect: "Gulu Effect",
        sneakers: "Sneakers"
    };

    return (
        <section className="shop-category">
            <div className="shop-category__title-banner container">
                <h1>{categoryTitles[props.category] || "Category"}</h1>
            </div>

            <div className="shop-category__controls container">
                <p className="shop-category__product-count">
                    <span>Showing 1-{Math.min(visibleItems, displayedProducts.length)}</span> of {displayedProducts.length} products
                </p>
                <div className="shop-category__filters">
                    {/* Show Brand Filter only if there are brands to filter by */}
                    {props.category === 'sneakers' && categoryBrands.length > 1 && (
                        <div className="filter-control">
                            <select value={selectedBrand} onChange={(e) => setSelectedBrand(e.target.value)}>
                                {categoryBrands.map(brand => (
                                    <option key={brand} value={brand}>{brand}</option>
                                ))}
                            </select>
                        </div>
                    )}
                    <div className="filter-control">
                        <select value={sortOrder} onChange={(e) => setSortOrder(e.target.value)}>
                            <option value="default">Sort by: Default</option>
                            <option value="price-asc">Price: Low to High</option>
                            <option value="price-desc">Price: High to Low</option>
                        </select>
                    </div>
                </div>
            </div>

            <div className="shop-category__products container">
                {displayedProducts.length > 0 ? (
                    displayedProducts.slice(0, visibleItems).map((item) => (
                        <Item
                            key={item.id} id={item.id} name={item.name} image={item.image}
                            new_price={item.new_price} old_price={item.old_price}
                        />
                    ))
                ) : (
                    <div className="shop-category__empty-state">
                        <p className="shop-category__no-products">No products yet, Coming soon 🚀</p>
                    </div>
                )}
            </div>

            {visibleItems < displayedProducts.length && (
                <div className="shop-category__loadmore">
                    <button onClick={handleLoadMore}>Load More</button>
                </div>
            )}
        </section>
    );
}

export default ShopCategory;